import PropTypes from 'prop-types';
import ResultTableRow from '../../../molecules/screener/result-table-row';
import ResultTableCard from '../../../molecules/screener/result-table-card';
import useDetectPrint from 'react-detect-print';

const ResultTableItem = ({ index, item, isExpanded, onClickExpandRow, performanceQuarterly, performanceAsOf, isTabletOrMobile, isSignatureResult, isMobile, onChangePerformanceTerm, showSalesCharge }) => {
  const isTabletOrMobileSize = useDetectPrint() ? false : isTabletOrMobile;

  if (isTabletOrMobileSize) {
    return (
      <ResultTableCard
        index={index}
        item={item}
        isExpanded={isExpanded}
        onClickExpandRow={onClickExpandRow}
        performanceQuarterly={performanceQuarterly}
        performanceAsOf={ performanceAsOf}
        isSignatureResult={isSignatureResult}
        isMobile={isMobile}
        onChangePerformanceTerm={onChangePerformanceTerm}
        showSalesCharge={showSalesCharge}
      />
    );
  }
  return (
    <ResultTableRow
      index={index}
      item={item}
      isExpanded={isExpanded}
      onClickExpandRow={onClickExpandRow}
      performanceQuarterly={performanceQuarterly}
      performanceAsOf={ performanceAsOf }
      isSignatureResult={isSignatureResult}
      showSalesCharge={showSalesCharge}
    />
  );
};

ResultTableItem.propTypes = {
  index: PropTypes.number,
  item: PropTypes.object,
  isExpanded: PropTypes.bool,
  onClickExpandRow: PropTypes.func,
  performanceAsOf: PropTypes.number,
  performanceQuarterly: PropTypes.bool,
  isTabletOrMobile: PropTypes.bool,
  isSignatureResult: PropTypes.bool,
  isMobile: PropTypes.bool,
  onChangePerformanceTerm: PropTypes.func,
  showSalesCharge: PropTypes.bool
};

export default ResultTableItem;
